$(function(){
  // Limited商品の場合数量制限を実施
  if( $('#js-hidden-is_limited').val() == 'limited' ){
    limitedQuantityControl();
  }
  // バリエーションの変更を検知して実行
  $(document).on('change','input.product-variant-id', function() {
    if( $('#js-hidden-is_limited').val() == 'limited' ){
      limitedQuantityControl();
    }
  });
});

// 数量制限
function limitedQuantityControl() {
  // 数量制限個数
  var limitedQuantity = 1;
  // カート内の同一バリエーションアイテムの個数を取得
  var sameVariationQuantity = getSameVaritaionQuantity();
  parseInt(sameVariationQuantity);
  // 数量制限をつける
  if ( sameVariationQuantity <= limitedQuantity ) {
    var maxQty = limitedQuantity - sameVariationQuantity;
  } else {
    var maxQty = 0;
  }
  var quantityInput = $('.quantity__input');
  quantityInput.max = maxQty;

  // 制限を超えている場合
  if ( sameVariationQuantity >= limitedQuantity ) {
    // 購入ボタンを使えなくする
    $('.product-form__submit').prop('disabled', true).addClass('disabled');
    // 数量選択を使えなくする
    $('.quantity__input').prop('readonly',true).addClass('disabled');
  } else {
    $('.product-form__submit').prop('disabled', false).removeClass('disabled');
    $('.quantity__input').prop('readonly',false).removeClass('disabled');
  }
}

// カート内の同一バリエーションアイテムの個数を取得
function getSameVaritaionQuantity() {
  var currentVariantId = getUrlParam("variant");
  if (currentVariantId == null) {
    currentVariantId = $('#js-hidden-first-variantsId').val(); // パラメータでバリアント指定がない場合は初期バリアントIDを指定
  }
  // カートデータを取得
  var cartData = getCartJSON();
  var cart = JSON.parse(cartData);

  var quantity = 0;
  // cart.itemからvariant_idが一致するitemsを探す
  if( cart.items != undefined ) {
    var item = cart.items.find( p => p.variant_id == currentVariantId);
    if(item) {
      // 見つかった場合
      quantity = item.quantity;
    }
  }

  return quantity;
}

function getCartJSON() {
  var result = $.ajax({
    url: '/cart.js',
    dataType: 'json',
    async: false
  }).responseText;
  return result;
}

function getUrlParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
